import { LoginForm } from '../components/auth/LoginForm';
import { usePageTitle } from '../hooks/usePageTitle';

export function LoginPage() {
  usePageTitle('Login — Hawkes Bridge');
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="bg-card rounded-xl shadow-sm p-8">
          <h1 className="text-2xl font-bold text-center text-ink mb-6">
            Welcome Back
          </h1>
          <p className="text-center text-ink-soft mb-8">
            Login to continue practicing your bridge bidding skills.
          </p>
          <LoginForm />
        </div>
      </div>
    </div>
  );
}
